import { ILeadsState } from '../../types/leads';

const defaultState: ILeadsState = {
  count: 0,
};

export function leadsReducer(state: ILeadsState = defaultState): ILeadsState {
  return state;
}
